/* eslint-disable @typescript-eslint/no-explicit-any */
import { ActionTree } from "vuex";
import { RootState } from "../types";
import { JobStagesInt } from "./types";

export const actions: ActionTree<JobStagesInt, RootState> = {};
